import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getSvgContent } from "../../../../Js/Common";
import { currentILTActionsSliceActions } from "../../../../Store/Slices/CurrentILTActions";
import { find } from "lodash";

const WwSVG = (props) => {
  const [svg, setSvg] = useState("");
  const SvgRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.data) {
      const getContent = async () => {
        console.log(":S:S:S:", props);
        let content = await getSvgContent(props.data.source);
        SvgRef.current.innerHTML = "";
        SvgRef.current.insertAdjacentHTML("afterbegin", "");
        SvgRef.current.parentElement.style.textAlign = "center";
        SvgRef.current.insertAdjacentHTML("afterbegin", content.data);
        dispatch(currentILTActionsSliceActions.setSvgLoad(true));
        SvgRef.current.setAttribute(
          "style",
          `height:${Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          )};width:100%;padding: 5px;`
        );
        if (props.parentData?.mime !== "wwimage") {
          setHeight();
        }
        if (props.data.svgFullScreen) {
          setHeight1();
        }
      };
      getContent();
    }

    return () => {
      dispatch(currentILTActionsSliceActions.setSvgLoad(false));
      SvgRef.current.innerHTML = "";
    };
  }, [props.data]);

  const setHeight = () => {
    let svgNode = find(SvgRef.current.childNodes, { nodeName: "svg" });
    if (window.innerHeight <= 768) {
      svgNode.setAttribute("height", "520");
      svgNode.setAttribute("width", "840");
    }
    if (window.innerWidth > 1366 && window.innerWidth < 1636) {
      svgNode.setAttribute("height", "620");
      svgNode.setAttribute("width", "1200");
    }
    if (window.innerWidth >= 1636) {
      svgNode.setAttribute("height", "800");
      svgNode.setAttribute("width", "1600");
    }
  };

  const setHeight1 = () => {
    let svgNode = find(SvgRef.current.childNodes, { nodeName: "svg" });
    svgNode.style.height = "90%";
    svgNode.style.width = "90%";
  };

  return <>{props.data && props.data.source && <span ref={SvgRef}></span>}</>;
};

export default WwSVG;
